<!-- 
  详情页 - 供应商联系人
  props:
    id: 详情id
 -->

<template>
	<div class="contacts">
		<ul class="item-list">
      <li class="item center" v-if="!contactData.length">暂无联系人</li>
      <li class="item" v-for="item in contactData">
        <div class="infos">
          <div class="user">
            <span class="text">{{item.name}}</span>
            <span class="tag" v-if="item.level">{{item.level}}</span>
            <span v-if="item.isMain" class="tag master">关键决策人</span>
          </div>
          <p class="phone">Tel：{{item.phoneArray | arrToStr}}</p>
          <span class="position">{{item.position}}</span>
        </div>
        <span v-if="item.isMain" class="master">关键决策人</span>
        <span class="edit" @click="editItem(item.id)">编辑</span>
        <span class="del" @click="handleDel(item.id)">删除</span>
      </li>
      <li class="item center">
        <el-button type="primary" @click="addNew">添加联系人</el-button>
      </li>
    </ul>

    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
	</div>
</template>

<script>
import Vue from 'vue'
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      contactData: [],
      addnewShow: false,
      addnewProp: {
        id: '',
        supplierId: this.id,
        module: 'supplierContact'
      },
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      }
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    getList () {
      let url = '/supplier/contactList.html'
      let params = {
        supplierId: this.id,
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.contactData = data.result
        } else {
          this.contactData = this.contactData.concat(data.result)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    },
    addNew () {
      // Vue.set(this.addnewProp, 'id', '')
      // this.openAddNew()
      var addnewProp = {
        id: '',
        supplierId: this.id,
        module: 'supplierContact'
      }
      this.$emit('openSupplierAddNew', addnewProp)
    },
    editItem (id) {
      Vue.set(this.addnewProp, 'id', id)
      // this.openAddNew()
      this.$emit('openSupplierAddNew', this.addnewProp)
    },
    // 打开 addnew 弹窗
    openAddNew () {
      this.addnewShow = true
      this.$nextTick(() => {
        this.$refs.addNew.dialogFormVisible = true
      })
    },
    handleDel (id) {
      MessageBox.confirm('确定删除该数据吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem(id)
      }).catch(() => {})
    },
    deleteItem (id) {
      let url = `/supplierContact/delete.html`
      let params = {
        id: [id]
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: '删除成功!'
        })
        this.getList()
      })
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  },
  filters: {
    arrToStr (arr) {
      let nums = arr.map((item) => {
        return item.telNum
      })
      return nums.join('/')
    }
  }
}
</script>

<style lang="less" scoped>
  .contacts .phone {
    padding: 10px 84px 10px 16px !important;
  }
  .contacts .infos .text {
    max-width: 30%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .contacts .infos .position {
    max-width: 20%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @import '../../../assets/less/detail-contact.less';
</style>


// WEBPACK FOOTER //
// contacts.vue?95441f6a